import { render, staticRenderFns } from "./customer-groups-modal.vue?vue&type=template&id=73d9306e&"
import script from "./customer-groups-modal.ts?vue&type=script&lang=ts&"
export * from "./customer-groups-modal.ts?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports